import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Lock, LogIn } from "lucide-react";

const LoginRequiredDialog = ({ open, onOpenChange, message }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = () => {
    onOpenChange(false);
    navigate("/login", { state: { from: location.pathname + location.search } });
  };

  const handleRegister = () => {
    onOpenChange(false);
    navigate("/register", { state: { from: location.pathname + location.search } });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] rounded-3xl sm:max-w-md" data-testid="login-required-dialog">
        <DialogHeader>
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-primary-50">
            <Lock className="h-7 w-7 text-primary-600" />
          </div>
          <DialogTitle className="text-center text-xl">Login Required</DialogTitle>
          <DialogDescription className="text-center pt-2">
            {message ||
              "You must login to use this feature and start earning cashback."}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col sm:space-x-0">
          <Button
            onClick={handleLogin}
            className="w-full bg-primary-600 hover:bg-primary-700"
            data-testid="login-required-login-btn"
          >
            <LogIn className="w-4 h-4 mr-2" />
            Login Now
          </Button>
          <Button
            variant="outline"
            onClick={handleRegister}
            className="w-full"
            data-testid="login-required-register-btn"
          >
            Create New Account
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LoginRequiredDialog;
